<template>
   	<div class="playDown" :class="{playDown2:!tgNum}">
   		<dl @click="showBigPlay">
   			<dt><img :src="imgUrl" onerror='javascript:this.src="http://www.xi-g.com/dist/logo.png"'/></dt>
   			<dd>
   				<h3>{{songName}}</h3>
   				<p>{{singerName}}</p>
   			</dd>
   		</dl>
   		<div class="play" :class="{'pause':isplay}" @click="playorp"></div>
   		<div class="next" @click="nextSong"></div>
   		<audio id="audioPlay" class="song" :src="songUrl" autoplay @ended="nextSong" @timeupdate="change"></audio>
   		<div class="showHide" @click="tgNum=!tgNum" :class="{showHide2:tgNum}">
   			<img src="../assets/images/to_top.png"/>
   		</div>
   	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
		tgNum:true,
      }
    },
    computed: {
    	...mapGetters(['songName','singerName','imgUrl','songUrl','isplay','iscurrent','songHash','songList'])
    },
    mounted:function(){
    	
    },
    methods: {
      playorp:function(){
      	if(this.songUrl){
      		this.$store.commit('isplayFlag',!this.isplay);
      		if (this.isplay) {
	          document.getElementById('audioPlay').play();
	          this.$store.commit('imgPause',false);
	        } else {
	          document.getElementById('audioPlay').pause();
	          this.$store.commit('imgPause',true);
	        }
	    }
      },
      nextSong:function(){
      	if(this.iscurrent<this.songList.length-1){
      		this.$store.commit('setIscurrent',this.iscurrent+1);
      		this.$store.commit('imgPause',false);
      	}else{
      		this.$store.commit('setIscurrent',0);
      	}
      	this.$store.dispatch('playSong');
      },
      showBigPlay(){
      	if(this.songUrl){
      		this.$store.commit('bigPlayShow',true);
      	}
      },
      change(){
      	$('.disCurrentLrc').css({'color':'#fff','font-size':'13px'}).last().css({'color':'#7de87d','font-size':'15.5px'});
      	var time = document.getElementById('audioPlay').currentTime;
      	this.$store.commit('mycurrentTime', time);
      }
    }
  }
</script>

<style>
.playDown{width: 100%;height: 10.4%;position: fixed;left: 0;bottom:0;background: rgba(0,0,0,0.85);z-index: 12;transition: all 0.4s;}
.playDown2{bottom:-10.4%;}
.playDown dl{width: 65%;height: 100%;float: left;}
.playDown dl dt{width: 22.79%;height: 80%;overflow: hidden;float: left;margin-left: 7px;margin-top: 7px;}
.playDown dl dt img{width: 100%;}
.playDown dl dd{float: left;color: #fff;margin-left: 16px;}
.playDown dl h3{margin-bottom: 5px;margin-top:10px;font-size: 14px;}
.playDown dl p{color: #ccc;}
.playDown .play{margin-left:20px;margin-top:17px;float: left;width: 7.96%;height: 43%;background: url(../assets/images/play.png) no-repeat center center;background-size: cover;}
.playDown .pause{background: url(../assets/images/pause.png) no-repeat center center;background-size: cover;}
.playDown .next{margin-top:17px;float: left;width: 7.96%;height: 43%;background: url(../assets/images/next.png) no-repeat center center;background-size: cover;margin-left: 20px;}

.showHide{width: 40px;height: 40px;background: rgba(0,0,0,0.7);border-radius: 50%; position: absolute;transform: rotate(180deg);top:-50px;left:10px;transition: all 0.3s;}
.showHide2{transform: none;}
.showHide img{width: 40px;}
</style>


// WEBPACK FOOTER //
// playDown.vue?58a65fa2